module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_15.4d5c000d.jpg";